import defaultClient from '@src/api/clients/default';

const URL = (path) => {
  return `dashboard/client-summary/${path}/`;
};

export function fetchClientSummaryByDate(payload = {}) {
  return defaultClient.request({
    url: URL('client-date'),
    payload,
  });
}

export function fetchVerticalSummary(payload = {}) {
  return defaultClient.request({
    url: URL('vertical'),
    payload,
  });
}

// One row per client across the date range, aggregated in SQL with full
// metric set + fee_weighted_spend_sum. Powers the Company Performance client
// table.
export function fetchClientSummary(payload = {}) {
  return defaultClient.request({
    url: URL('client'),
    payload,
  });
}

// One row per (vertical, client) for the Company Performance vertical
// drilldown. Lets the Vertical Performance Table expand each vertical into
// the clients contributing to it.
export function fetchVerticalClientBreakdown(payload = {}) {
  return defaultClient.request({
    url: URL('vertical-client-breakdown'),
    payload,
  });
}

// Per-day totals across all matching clients, aggregated in SQL (includes
// fee_weighted_spend_sum). Powers the Company Performance chart + DoD table.
export function fetchClientSummaryDateRollup(payload = {}) {
  return defaultClient.request({
    url: URL('date-rollup'),
    payload,
  });
}

// Per-month totals across all matching clients, aggregated in SQL. Powers the
// Company Performance MoM table.
export function fetchClientSummaryMonthRollup(payload = {}) {
  return defaultClient.request({
    url: URL('month-rollup'),
    payload,
  });
}

export default {
  fetchClientSummaryByDate,
  fetchVerticalSummary,
  fetchClientSummary,
  fetchVerticalClientBreakdown,
  fetchClientSummaryDateRollup,
  fetchClientSummaryMonthRollup,
};
